import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function BookingBasicComponent ({jobs,shippingStatus,customers,salesOrders,selectedOrderBooking,onInnerBasicFormChange}: any) {
  console.log(salesOrders,"salesOrders")
  console.log(selectedOrderBooking,"selectedOrderBooking")
  console.log(customers,"customers")
    return (
    <>
    <AccordionContainer
child={
  <><div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
     <InputContainer
               label="Logistics Order"
               labelField="TrackingNumber"
               list={salesOrders}
               onValueChange={(event: any) => {
                onInnerBasicFormChange(
                   event.target.value,
                   'LogisticsOrderId'

                 );
               }}
               optionName='Choose LogisticsOrder'
               type="select"
               value={selectedOrderBooking?.LogisticsOrderId}
               valueField="Id"
           />
      <InputContainer
        label="Invoice Number"
        name="InvoiceNumber"
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'InvoiceNumber'

          );
        } }
        type="text"
        value={selectedOrderBooking?.InvoiceNumber} />
        <InputContainer
                            label="Customer name"
                            labelField="UserName"
                            list={customers}
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                event.target.value,
                                'CustomerId'
                              );
                            }}
                            optionName='Choose Customer'
                            type="select"
                            value={selectedOrderBooking?.CustomerId}
                            valueField="Id"
                        />
        
       {/* <InputContainer
               label="Job"
               labelField="Message.TransportAgentName"
               list={jobs}
               onValueChange={(event: any) => {
                onInnerBasicFormChange(
                   event.target.value,
                   'JobId'

                 );
               }}
               optionName='Choose Job'
               type="select"
               value={selectedOrderBooking?.JobId}
               valueField="Message.Id"
           />
      */}
      <InputContainer
        label="Booking Status"
        labelField="Text"
        list={shippingStatus}
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'LogisticsOrderBookingStatusId'
          );
        } }
        optionName='Choose ShippingStatus'
        type="select"
        value={selectedOrderBooking?.LogisticsOrderBookingStatusId}
        valueField="Value" />
    </div>
    <div className='col-span-full'>
        <InputContainer
        label="Description"
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'Description'
          );
        } }
        type="text"
        value={selectedOrderBooking?.Description} /></div>
        </>
}
expandedPanel="basicInfo"
headerTitle="Basic Info"
/>
    </>
  )
}